'use client';

import React from 'react';
import { Modal, ModalProps } from './Modal';
import { DialogHeader } from './DialogHeader';
import { DialogBody } from './DialogBody';
import { DialogFooter } from './DialogFooter';
import { Button } from '../Button';

export type FormDialogProps = Omit<ModalProps, 'children'> & {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  submitLabel?: string;
  cancelLabel?: string;
  secondaryAction?: React.ReactNode;
  loading?: boolean;
  disableSubmit?: boolean;
  footerAlign?: 'start' | 'center' | 'end' | 'space-between';
  children: React.ReactNode;
};

export function FormDialog({
  title,
  subtitle,
  onSubmit,
  submitLabel = 'Save',
  cancelLabel = 'Cancel',
  secondaryAction,
  loading = false,
  disableSubmit = false,
  footerAlign = 'end',
  children,
  onClose,
  ...modalProps
}: FormDialogProps) {
  const headerId = 'form-dialog-title';
  const bodyId = 'form-dialog-body';

  return (
    <Modal
      {...modalProps}
      onClose={onClose}
      labelledBy={headerId}
      describedBy={bodyId}
      scrollable
    >
      <form
        onSubmit={(e) => {
          e.stopPropagation();
          onSubmit(e);
        }}
        style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
          flex: 1
        }}
      >
        <DialogHeader id={headerId} title={title} subtitle={subtitle} />
        <DialogBody>
          <div id={bodyId}>{children}</div>
        </DialogBody>
        <DialogFooter align={footerAlign}>
          {secondaryAction}
          <Button
            variant="secondary"
            type="button"
            onClick={onClose}
            disabled={loading}
          >
            {cancelLabel}
          </Button>
          <Button type="submit" disabled={loading || disableSubmit}>
            {submitLabel}
          </Button>
        </DialogFooter>
      </form>
    </Modal>
  );
}
